import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { goToScene } from "../main";
import InventoryHUD from "../ui/inventory";
import Extractor from "../actors/extractor";
import Bottler from "../actors/Bottler";

export class HoneyHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 13 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 6;
  }
  onInitialize(engine) {
    this.engine = engine;
    Resources.HoneyHouseMap.addToScene(this);

    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);

    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    this.door = new ex.Trigger({
      pos: new ex.Vector(17 * 16, 16 * 16),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        this.inventoryHUD.destroy();
        goToScene("home");
      },
    });
    this.extractor = new Extractor(this);
    this.add(this.extractor);
    this.bottler = new Bottler(this);
    this.add(this.bottler);
    this.add(this.door);
    this.extractorCollision = false;
    this.bottlerCollision = false;
  }
  onActivate() {
    this.inventoryHUD = new InventoryHUD();
  }
  setCollision(ans, type) {
    console.log("collision: ", type, ans);
    if (type == "extractor") {
      if (ans) {
        this.extractorCollision = true;
      } else {
        this.extractorCollision = false;
      }
    } else if (type == "bottler") {
      if (ans) {
        this.bottlerCollision = true;
      } else {
        this.bottlerCollision = false;
      }
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      console.log(
        "extractorCollision: ",
        this.extractorCollision,
        " bottlercoll ",
        this.bottlerCollision
      );
      if (this.extractorCollision && !this.bottlerCollision) {
        this.inventoryHUD.destroy();
        this.extractor.destroyNotification();
        this.extractorCollision = false;
        goToScene("extract");
      } else if (this.bottlerCollision && !this.extractorCollision) {
        this.inventoryHUD.destroy();
        this.bottler.destroyNotification();
        this.bottlerCollision = false;
        goToScene("bottling");
      }
    }
  }
}
